// -- Application
export const APP_RESET_STATE = 'APP_RESET_STATE'
export const APP_RESET_STEP_STATUS = 'APP_RESET_STEP_STATUS'
export const APP_SET_CAMPGROUND = 'APP_SET_CAMPGROUND'
export const APP_SET_CURRENCY = 'APP_SET_CURRENCY'
export const APP_SET_LANGUAGE = 'APP_SET_LANGUAGE'
export const APP_SET_LANGUAGE_SLUG = 'APP_SET_LANGUAGE_SLUG'
export const APP_SET_TESTMODE = 'APP_SET_TESTMODE'
export const APP_SET_LOADER = 'APP_SET_LOADER'
export const APP_SET_STEP = 'APP_SET_STEP'
export const APP_SET_STEP_STATUS = 'APP_SET_STEP_STATUS'
export const APP_TOGGLE_BOOKING_DETAILS = 'APP_TOGGLE_BOOKING_DETAILS'
export const APP_SET_TITLE = 'APP_SET_TITLE'

// -- Campground
export const CAMPGROUND_RESET_STATE = 'CAMPGROUND_RESET_STATE'
export const CAMPGROUND_SET_AVAILABLE_CAMPSITES = 'CAMPGROUND_SET_AVAILABLE_CAMPSITES'
export const CAMPGROUND_SET_AVAILABLE_EXTRAS = 'CAMPGROUND_SET_AVAILABLE_EXTRAS'
export const CAMPGROUND_SET_CAMPGROUND = 'CAMPGROUND_SET_CAMPGROUND'
export const CAMPGROUND_SET_CAMPSITE_TYPES = 'CAMPGROUND_SET_CAMPSITE_TYPES'
export const CAMPGROUND_SET_COUNTRIES = 'CAMPGROUND_SET_COUNTRIES'
export const CAMPGROUND_SET_CURRENCIES = 'CAMPGROUND_SET_CURRENCIES'
export const CAMPGROUND_SET_LANGUAGES = 'CAMPGROUND_SET_LANGUAGES'
export const CAMPGROUND_SET_SESSION_TIMEOUT = 'CAMPGROUND_SET_SESSION_TIMEOUT'
export const CAMPGROUND_SET_ADYEN_VERSION = 'CAMPGROUND_SET_ADYEN_VERSION'
export const CAMPGROUND_SET_URLS = 'CAMPGROUND_SET_URLS'
export const CAMPGROUND_STATUS_ERROR = 'CAMPGROUND_STATUS_ERROR'
export const CAMPGROUND_STATUS_LOADING = 'CAMPGROUND_STATUS_LOADING'
export const CAMPGROUND_STATUS_SUCCESS = 'CAMPGROUND_STATUS_SUCCESS'

// -- Booking
export const BOOKING_RESET_STATE = 'BOOKING_RESET_STATE'
export const BOOKING_SET_AID = 'BOOKING_SET_AID'
export const BOOKING_SET_BILLING = 'BOOKING_SET_BILLING'
export const BOOKING_SET_CAR = 'BOOKING_SET_CAR'
export const BOOKING_SET_CHECKOUT = 'BOOKING_SET_CHECKOUT'
export const BOOKING_SET_COMPLETED = 'BOOKING_SET_COMPLETED'
export const BOOKING_SET_CONFIRMATION = 'BOOKING_SET_CONFIRMATION'
export const BOOKING_SET_DATES = 'BOOKING_SET_DATES'
export const BOOKING_SET_DISPLAYED_DATE = 'BOOKING_SET_DISPLAYED_DATE'
export const BOOKING_SET_EXTRA = 'BOOKING_SET_EXTRA'
export const BOOKING_SET_PERSON = 'BOOKING_SET_PERSON'
export const BOOKING_SET_PRICE = 'BOOKING_SET_PRICE'
export const BOOKING_SET_SELECTED_CAMPSITE = 'BOOKING_SET_SELECTED_CAMPSITE'
export const BOOKING_SET_SELECTED_SEASONS = 'BOOKING_SET_SELECTED_SEASONS'
export const BOOKING_SET_TOKEN = 'BOOKING_SET_TOKEN'
export const BOOKING_SET_TRAVELLER = 'BOOKING_SET_TRAVELLER'
export const BOOKING_RESET_TIMER = 'BOOKING_RESET_TIMER'
export const BOOKING_SET_OLD_BOOKING_ID = 'BOOKING_SET_OLD_BOOKING_ID'
